module.exports = "../images/fishing-v2@2x.jpg?v=f704df9";